import { render, staticRenderFns } from "./workerPromotion.vue?vue&type=template&id=95959e26&scoped=true&"
import script from "./workerPromotion.vue?vue&type=script&lang=js&"
export * from "./workerPromotion.vue?vue&type=script&lang=js&"
import style0 from "./workerPromotion.vue?vue&type=style&index=0&id=95959e26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95959e26",
  null
  
)

export default component.exports